"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllEvmNftsFromWallet = void 0;
const config_1 = __importDefault(require("../config"));
const backend_1 = require("../../factory/backend");
const Logger = 'CandyShopSDK/fetchEvmNftsFromWallet';
const DEFAULT_PAGE_SIZE_LIMIT = 20;
/**
 * Will not support cache flow since we can not know which page we should fetch for
 * those removed/added Evm nfts to update cached nfts.
 * @note Fetch all NFTs from target wallet on certain Evm chain
 * @param walletAddress
 * @param chain Blockchain
 * @param fetchNFTBatchParam the param object to specify batchCallback and batchSize
 * @param collections specify the EVM collection to fetch by array of smart contract address
 * @returns array of the SingleTokenInfo in Promise
 */
const fetchAllEvmNftsFromWallet = async (walletAddress, chain, fetchNFTCollectionParams, fetchNFTBatchParam) => {
    var _a;
    // Apply the batchCallback logic to page limit call from DB
    const limit = (_a = fetchNFTBatchParam === null || fetchNFTBatchParam === void 0 ? void 0 : fetchNFTBatchParam.batchSize) !== null && _a !== void 0 ? _a : DEFAULT_PAGE_SIZE_LIMIT;
    const totalCount = Number.MAX_SAFE_INTEGER;
    const fetchQuery = {
        limit: limit,
        chain: chain
    };
    let singleTokenInfos = [];
    let evmNfts = null;
    while (totalCount > singleTokenInfos.length) {
        evmNfts = await fetchEvmNftsFromWalletByLimit(walletAddress, fetchNFTCollectionParams.shopId, fetchQuery);
        if (evmNfts.success) {
            singleTokenInfos = singleTokenInfos.concat(evmNfts.result);
        }
        if (fetchNFTBatchParam === null || fetchNFTBatchParam === void 0 ? void 0 : fetchNFTBatchParam.batchCallback) {
            // Only provide the batch result when batchCallback is specified.
            fetchNFTBatchParam.batchCallback(singleTokenInfos);
        }
        // If cursor is available, continue to fetch until unavailable.
        if (evmNfts.cursor) {
            fetchQuery.cursor = evmNfts.cursor;
        }
        else {
            break;
        }
    }
    console.log(`${Logger}: fetchAllEvmNftsFromWallet tokenInfos=`, singleTokenInfos);
    return singleTokenInfos;
};
exports.fetchAllEvmNftsFromWallet = fetchAllEvmNftsFromWallet;
const fetchEvmNftsFromWalletByLimit = async (walletAddress, shopId, query) => {
    return (0, backend_1.fetchEvmChainNftsFromWallet)(config_1.default, walletAddress, shopId, query);
};
